import { parseObjectWithDate } from "~/utils/json";

export const typesMap = {
    DateTime: {
        serialize: (parsed: Date | null) => parsed && parsed.toJSON(),
        parseValue: (raw: string | null) => raw && parseObjectWithDate(raw),
    },
    Any: {
        serialize: (parsed: any | null) => parsed,
        parseValue: (raw: any | null) => raw && parseObjectWithDate(raw),
    },
};
